import _typeof from '/var/www/html/node_modules/babel-runtime/helpers/typeof';
import translations from '~/trans/all.js';
import axios from 'axios';

function notifyMissingKey(key) {
  if (!global.toTrans) {
    global.toTrans = {};
  }
  global.toTrans[key] = key;

  if (typeof global.sendTransHandler !== 'undefined') {
    clearTimeout(global.sendTransHandler);
  }

  global.sendTransHandler = setTimeout(function () {
    var keys = [];
    for (var transKey in global.toTrans) {
      keys.push(transKey);
    }

    axios.post(global.getEndPoint() + 'api/translations', { keys: keys }).then(function (response) {
      //console.log(response);
    });
  }, 10000);
}

export default function (key, context) {
  var translation = key;
  if (!global.selectedLang) {
    global.selectedLang = 'en';
  }
  //if (translations[global.selectedLang] !== undefined || translations[global.selectedLang][key] !== undefined) {
  if (typeof translations[global.selectedLang] !== 'undefined' && typeof translations[global.selectedLang][key] !== 'undefined') {
    translation = translations[global.selectedLang][key];
  } else {
    notifyMissingKey(key);
  }

  if ((typeof context === 'undefined' ? 'undefined' : _typeof(context)) === 'object') {
    var matches = translation.match(/(%([^%]|%%)*%)/g);

    if (matches) {
      matches.forEach(function (match) {
        var prop = match.replace(/[%]+/g, '');
        if (!Object.prototype.hasOwnProperty.call(context, prop)) {
          return;
        }

        var regex = new RegExp(match, 'g');
        translation = translation.replace(regex, context[prop]);
      });
    }
  }

  return translation;
}


//////////////////
// WEBPACK FOOTER
// ./plugins/trans-lib.js
// module id = ./plugins/trans-lib.js
// module chunks = 54